package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_area_domain_di_AddEditAreaUseCaseModule : Module get() = module {
	single() { _ -> com.essntl.features.area.domain.usecase.AddEditAreaUseCase(areaRepository=get()) } 
}
public val com.essntl.features.area.domain.di.AddEditAreaUseCaseModule.module : org.koin.core.module.Module get() = com_essntl_features_area_domain_di_AddEditAreaUseCaseModule
